export default __webpack_public_path__ + "static/media/invalid-name@2x.c6c9d724.png";